// Client for the "Suggested Workflow" helper stream — the Haiku Q&A assistant
// for non-technical users (see api/src/services/workflowHelperService.js).
// Same SSE envelope + reader shape as streamChatWorkflowPlan in
// workflowStorage.js, kept in its own module so the helper stays separable
// from the planner plumbing.
const { getAccessToken, getApiBasePath } = require('./apiClient');
const { getActiveLanguage } = require('./language');

// messages: [{role, content}] raw helper chat history.
// handlers: { onEvent(evt), onError(err), onClose() }
// Returns an abort() function.
function streamWorkflowHelperChat(messages, handlers) {
  var h = handlers || {};
  var token = getAccessToken();
  var abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

  fetch(getApiBasePath() + '/workflow-planner/helper/stream', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? ('Bearer ' + token) : ''
    },
    body: JSON.stringify({ messages: messages, language: getActiveLanguage() }),
    signal: abortController ? abortController.signal : undefined
  }).then(function(response) {
    if (!response.ok) {
      throw new Error('Stream request failed with status ' + response.status);
    }
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';

    function processChunks() {
      return reader.read().then(function(result) {
        if (result.done) {
          if (h.onClose) h.onClose();
          return;
        }
        buffer += decoder.decode(result.value, { stream: true });
        var lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (var i = 0; i < lines.length; i++) {
          var line = lines[i].trim();
          if (!line || line.startsWith(':')) continue;
          if (line.startsWith('data: ')) {
            try {
              var payload = JSON.parse(line.slice(6));
              if (h.onEvent) h.onEvent(payload);
            } catch (e) {
              // ignore malformed
            }
          }
        }
        return processChunks();
      });
    }

    return processChunks();
  }).catch(function(err) {
    if (err && err.name === 'AbortError') return;
    if (h.onError) h.onError(err);
  });

  return function abort() {
    if (abortController) abortController.abort();
  };
}

module.exports = { streamWorkflowHelperChat: streamWorkflowHelperChat };
